import { render, staticRenderFns } from "./ModalPointsRedemption.vue?vue&type=template&id=de132508&scoped=true"
import script from "./ModalPointsRedemption.vue?vue&type=script&lang=js"
export * from "./ModalPointsRedemption.vue?vue&type=script&lang=js"
import style0 from "./ModalPointsRedemption.vue?vue&type=style&index=0&id=de132508&prod&scoped=true&lang=css"
import style1 from "./ModalPointsRedemption.vue?vue&type=style&index=1&id=de132508&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de132508",
  null
  
)

export default component.exports